import { render, staticRenderFns } from "./input-general-direction.vue?vue&type=template&id=6be0ea20"
import script from "./input-general-direction.vue?vue&type=script&lang=js"
export * from "./input-general-direction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports